import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="/logo.png" alt="FINBRO Logo" className="w-10 h-10 rounded-lg object-cover" />
              <span className="text-2xl font-bold text-gray-900">FINBRO</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" className="flex items-center gap-2">
                <ArrowLeft className="h-4 w-4" /> Înapoi
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Politica de Confidențialitate
          </h1>

          <p className="text-gray-600 mb-8">
            Această Politică de Confidențialitate descrie modul în care CHANGEMATRIC SRL 
            ("noi", "FINBRO") colectează, utilizează și protejează datele dumneavoastră 
            cu caracter personal atunci când utilizați platforma FINBRO.
          </p>

          {/* Secțiunea 1 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Operatorul de Date</h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="font-semibold">CHANGEMATRIC SRL</p>
              <p>CUI: 41017573</p>
              <p>Nr. Reg. Com.: J40/5503/2019</p>
              <p>Email: contact@finbro.ro</p>
            </div>
          </section>

          {/* Secțiunea 2 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Datele Colectate</h2>
            <p className="text-gray-700 mb-4">Colectăm următoarele categorii de date:</p>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">2.1 Date de Identificare</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
              <li>Nume și prenume</li>
              <li>Adresa de email</li>
              <li>Număr de telefon</li>
              <li>CNP (pentru clienții care completează formulare de credit)</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">2.2 Date ale Companiei (pentru brokeri)</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 mb-4">
              <li>Denumirea companiei</li>
              <li>CUI / Cod fiscal</li>
              <li>Număr Registrul Comerțului</li>
              <li>Adresa sediului social</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-800 mb-3">2.3 Date Tehnice</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              <li>Adresa IP</li>
              <li>Tipul browserului și dispozitivului</li>
              <li>Date de navigare pe platformă</li>
            </ul>
          </section>

          {/* Secțiunea 3 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Scopurile Prelucrării</h2>
            <p className="text-gray-700 mb-4">Utilizăm datele dumneavoastră pentru:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Furnizarea serviciilor platformei FINBRO</li>
              <li>Crearea și gestionarea conturilor de utilizator</li>
              <li>Procesarea cererilor de credit și generarea documentelor</li>
              <li>Comunicarea cu dumneavoastră privind serviciile noastre</li>
              <li>Îmbunătățirea platformei și a experienței utilizatorilor</li>
              <li>Respectarea obligațiilor legale</li>
            </ul>
          </section>

          {/* Secțiunea 4 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Temeiul Legal</h2>
            <p className="text-gray-700 mb-4">Prelucrăm datele pe baza:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Consimțământului</strong> - pentru procesarea datelor în scopuri de marketing</li>
              <li><strong>Executării contractului</strong> - pentru furnizarea serviciilor platformei</li>
              <li><strong>Interesului legitim</strong> - pentru îmbunătățirea serviciilor și securitatea platformei</li>
              <li><strong>Obligațiilor legale</strong> - pentru conformarea cu legislația în vigoare</li>
            </ul>
          </section>

          {/* Secțiunea 5 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Partajarea Datelor</h2>
            <p className="text-gray-700 mb-4">
              Nu vindem datele dumneavoastră cu caracter personal. Putem partaja date cu:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Furnizorii de servicii care ne ajută să operăm platforma (hosting, email)</li>
              <li>Autoritățile publice, când legea ne obligă</li>
              <li>Brokerii, în cazul clienților care completează formulare de credit (doar datele necesare procesării cererii)</li>
            </ul>
          </section>

          {/* Secțiunea 6 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Perioada de Păstrare</h2>
            <p className="text-gray-700 mb-4">
              Păstrăm datele dumneavoastră atât timp cât este necesar pentru scopurile pentru 
              care au fost colectate:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Datele contului: pe durata existenței contului + 3 ani</li>
              <li>Datele cererilor de credit: 5 ani conform legislației</li>
              <li>Date de facturare: 10 ani conform legislației fiscale</li>
            </ul>
          </section>

          {/* Secțiunea 7 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Drepturile Dumneavoastră</h2>
            <p className="text-gray-700 mb-4">Conform GDPR, aveți următoarele drepturi:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Dreptul de acces</strong> - să solicitați o copie a datelor dumneavoastră</li>
              <li><strong>Dreptul la rectificare</strong> - să corectați datele inexacte</li>
              <li><strong>Dreptul la ștergere</strong> - să solicitați ștergerea datelor</li>
              <li><strong>Dreptul la restricționare</strong> - să limitați prelucrarea datelor</li>
              <li><strong>Dreptul la portabilitate</strong> - să primiți datele într-un format structurat</li>
              <li><strong>Dreptul de opoziție</strong> - să vă opuneți prelucrării în anumite situații</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Pentru exercitarea acestor drepturi, contactați-ne la: <strong>contact@finbro.ro</strong>
            </p>
          </section>

          {/* Secțiunea 8 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Securitatea Datelor</h2>
            <p className="text-gray-700">
              Implementăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor 
              dumneavoastră, inclusiv criptarea datelor în tranzit și în repaus, controlul 
              accesului și monitorizarea securității.
            </p>
          </section>

          {/* Secțiunea 9 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Cookie-uri</h2>
            <p className="text-gray-700 mb-4">
              Utilizăm cookie-uri pentru a asigura funcționarea platformei și a îmbunătăți 
              experiența utilizatorilor. Tipurile de cookie-uri folosite:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Cookie-uri esențiale</strong> - necesare pentru funcționarea platformei</li>
              <li><strong>Cookie-uri de performanță</strong> - pentru analiza utilizării platformei</li>
              <li><strong>Cookie-uri funcționale</strong> - pentru memorarea preferințelor</li>
            </ul>
          </section>

          {/* Secțiunea 10 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Modificări</h2>
            <p className="text-gray-700">
              Ne rezervăm dreptul de a actualiza această Politică de Confidențialitate. 
              Vă vom notifica despre modificările semnificative prin email sau prin 
              intermediul platformei.
            </p>
          </section>

          {/* Secțiunea 11 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contact și Plângeri</h2>
            <p className="text-gray-700 mb-4">
              Pentru întrebări sau plângeri privind prelucrarea datelor:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p><strong>Email:</strong> contact@finbro.ro</p>
              <p className="mt-2"><strong>Autoritatea de Supraveghere:</strong></p>
              <p>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</p>
              <p>Website: <a href="https://www.dataprotection.ro" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a></p>
            </div>
          </section>

          <div className="border-t pt-6 mt-8">
            <p className="text-gray-500 text-sm">
              Ultima actualizare: Ianuarie 2025
            </p>
          </div>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-400">
            © 2025 FINBRO by CHANGEMATRIC SRL. Toate drepturile rezervate.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;